import Header from "@widgets/Header";
import type { ReactElement } from "react";

export function MainLayout(page: ReactElement) {
	return (
		<div className="flex flex-col gap-4 h-full p-2 overflow-y-auto">
			<Header />
			<main className="flex flex-col gap-4 min-h-full">{page}</main>
		</div>
	);
}
